import { createRouter, createWebHistory } from 'vue-router'
import { api, setCsrfToken } from './services/api'
import HomePage from './views/HomePage.vue'
import BottlePage from './views/BottlePage.vue'
import RehidePage from './views/RehidePage.vue'
import AdminLogin from './views/admin/AdminLogin.vue'
import AdminShell from './views/admin/AdminShell.vue'
import AdminDashboard from './views/admin/AdminDashboard.vue'
import AdminQuotes from './views/admin/AdminQuotes.vue'
import AdminQuoteDetail from './views/admin/AdminQuoteDetail.vue'
import AdminBottles from './views/admin/AdminBottles.vue'
import AdminBottleDetail from './views/admin/AdminBottleDetail.vue'
import AdminBottlePrint from './views/admin/AdminBottlePrint.vue'
import AdminComments from './views/admin/AdminComments.vue'
import AdminReports from './views/admin/AdminReports.vue'
import AdminModeration from './views/admin/AdminModeration.vue'
import AdminAISettings from './views/admin/AdminAISettings.vue'

export const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    { path: '/', component: HomePage },
    { path: '/b/:id', component: BottlePage },
    { path: '/b/:id/rehide', component: RehidePage },
    { path: '/admin/login', component: AdminLogin, meta: { publicAdmin: true } },
    {
      path: '/admin',
      component: AdminShell,
      children: [
        { path: '', component: AdminDashboard },
        { path: 'quotes', component: AdminQuotes },
        { path: 'quotes/:id', component: AdminQuoteDetail },
        { path: 'bottles', component: AdminBottles },
        { path: 'bottles/print', component: AdminBottlePrint },
        { path: 'bottles/:id', component: AdminBottleDetail },
        { path: 'comments', component: AdminComments },
        { path: 'reports', component: AdminReports },
        { path: 'moderation', component: AdminModeration },
        { path: 'settings/ai', component: AdminAISettings },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

router.beforeEach(async (to) => {
  if (!to.path.startsWith('/admin') || to.meta.publicAdmin) return true
  try {
    const session = await api<{ csrfToken: string }>('/admin/auth/me')
    setCsrfToken(session.csrfToken)
    return true
  } catch {
    setCsrfToken(null)
    return { path: '/admin/login', query: { redirect: to.fullPath } }
  }
})
